// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__MhwdY{
    /* height:91px; */
    height:82px; 
    width:100%;
    padding:0 10%;
    color: #fff;
    display:flex;
    justify-content: space-between;
    align-items:center;
    position:absolute;
    z-index:1000;
    bottom:0;
    left:0;
    direction:rtl;
}
 .styles_downloadIcon__TUkw-{
    /* position: absolute;
    bottom:10px;
    left:10px; */
    cursor:pointer;
    padding: 4px;
    background: rgba(0,0,0,0.6);
    border-radius: 4px;
      color: unset !important; 
   filter: unset !important;
   margin:0;
  }
  .styles_forwardIcon__mRhYR{
    transform: rotateY(180deg);
  }`, "",{"version":3,"sources":["webpack://./../src/renderer/components/SelectedNavbar/styles.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,WAAW;IACX,UAAU;IACV,aAAa;IACb,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,QAAQ;IACR,MAAM;IACN,aAAa;AACjB;CACC;IACG;;gBAEY;IACZ,cAAc;IACd,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;MAChB,uBAAuB;GAE1B,wBAAwB;GACxB,QAAQ;EACT;EACA;IACE,0BAA0B;EAC5B","sourcesContent":[".container{\n    /* height:91px; */\n    height:82px; \n    width:100%;\n    padding:0 10%;\n    color: #fff;\n    display:flex;\n    justify-content: space-between;\n    align-items:center;\n    position:absolute;\n    z-index:1000;\n    bottom:0;\n    left:0;\n    direction:rtl;\n}\n .downloadIcon{\n    /* position: absolute;\n    bottom:10px;\n    left:10px; */\n    cursor:pointer;\n    padding: 4px;\n    background: rgba(0,0,0,0.6);\n    border-radius: 4px;\n      color: unset !important; \n    -webkit-filter: unset !important; \n   filter: unset !important;\n   margin:0;\n  }\n  .forwardIcon{\n    transform: rotateY(180deg);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__MhwdY`,
	"downloadIcon": `styles_downloadIcon__TUkw-`,
	"forwardIcon": `styles_forwardIcon__mRhYR`
};
export default ___CSS_LOADER_EXPORT___;
